export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-price-tag-5481282f9234375b7cf1f60202bb5f73.svg";